import { render, staticRenderFns } from "./DataSingleFolderRegister.vue?vue&type=template&id=02b5425c&"
import script from "./DataSingleFolderRegister.vue?vue&type=script&lang=js&"
export * from "./DataSingleFolderRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports